// extracted by mini-css-extract-plugin
module.exports = {"ghost_ui_loading":"AppStyles_ghost_ui_loading__36_s4"};